export const PAGINATION = {
  page: 1,
  size: 25,
}
export const PAYMENTS = [{ value: 'IncentivePayments', label: '奖励金' }]
export const FINDPAYMENTS = (value) => {
  return PAYMENTS.find((item) => item.value === value).label
}
